import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CalendarPlus } from 'lucide-react';
import { getMyGym, saveSlotOverride, deleteSlotOverride } from '../api/gymApi';
import GymCalendar from '../components/calendar/GymCalendar';

export default function PricingSlotsPage() {
  const [gym, setGym] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyGym()
      .then(g => setGym(g))
      .catch(() => setGym(null))
      .finally(() => setLoading(false));
  }, []);

  async function handleSaveOverride(date, slots) {
    const updated = await saveSlotOverride(date, slots);
    setGym(updated);
  }

  async function handleResetOverride(date) {
    const updated = await deleteSlotOverride(date);
    setGym(updated);
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center py-40">
        <div className="w-10 h-10 rounded-full border-4 border-[#e8f0fe] dark:border-[#1a2e4c] border-t-[#1a73e8] animate-spin" />
      </div>
    );
  }

  if (!gym) {
    return (
      <div className="max-w-md mx-auto text-center py-16">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 bg-[#e8f0fe] dark:bg-[#1a2e4c] text-[#1a73e8]">
          <CalendarPlus className="w-7 h-7" />
        </div>
        <h3 className="font-semibold text-base text-[#202124] dark:text-[#e8eaed]">No gym listing yet</h3>
        <p className="text-sm text-[#5f6368] dark:text-[#9aa0a6] mt-1">Create your gym first to set up slots.</p>
        <Link to="/my-gym"
          className="inline-block mt-4 text-sm font-semibold text-white px-5 py-2.5 rounded-full bg-[#1a73e8] hover:bg-[#1557b0]">
          Create Gym Listing
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      <GymCalendar
        weeklySlots={gym.weeklySlots}
        slotOverrides={gym.slotOverrides || []}
        onSaveOverride={handleSaveOverride}
        onResetOverride={handleResetOverride}
      />
    </div>
  );
}
